import { getTheme, DEFAULT_THEME_ID } from '@/themes';

let currentTheme = getTheme(DEFAULT_THEME_ID);

/**
 * 将主题颜色/渐变写入 CSS 变量，挂载到 document.documentElement
 * @param {object} theme
 */
export function applyThemeVariables(theme) {
  const root = document.documentElement;
  const { id, colors = {}, gradients = {} } = theme;

  root.setAttribute('data-theme', id);

  Object.entries(colors).forEach(([key, value]) => {
    root.style.setProperty(`--pay-color-${camelToKebab(key)}`, value);
  });

  Object.entries(gradients).forEach(([key, value]) => {
    root.style.setProperty(`--pay-gradient-${camelToKebab(key)}`, value);
  });
}

/**
 * 加载并应用主题
 * @param {string|number} [themeId]
 * @returns {object} theme
 */
export function loadTheme(themeId) {
  currentTheme = getTheme(themeId);
  applyThemeVariables(currentTheme);
  return currentTheme;
}

/** 获取当前已加载的主题 */
export function getCurrentTheme() {
  return currentTheme;
}

/** 获取主题图片 URL */
export function getThemeImage(key) {
  if (!Object.prototype.hasOwnProperty.call(currentTheme?.images || {}, key)) {
    return '';
  }
  const img = currentTheme.images[key];
  return img || '';
}

/** 获取主题颜色 */
export function getThemeColor(key) {
  return currentTheme?.colors?.[key] || '';
}

/** 获取主题渐变 */
export function getThemeGradient(key) {
  return currentTheme?.gradients?.[key] || '';
}

/** 获取主题文案，path 如 paymentAccountPopup.title */
export function getThemeCopy(path, locale) {
  const segments = String(path || '').split('.');
  let value = currentTheme?.copy;
  for (let i = 0; i < segments.length; i += 1) {
    value = value?.[segments[i]];
  }
  return resolveLocalizedCopy(value, locale);
}

function camelToKebab(str) {
  return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}

function resolveLocalizedCopy(value, locale) {
  if (value && typeof value === 'object') {
    return value[locale] || value.en || value.default || '';
  }
  return value || '';
}

export default {
  loadTheme,
  getCurrentTheme,
  getThemeImage,
  getThemeColor,
  getThemeGradient,
  getThemeCopy,
  applyThemeVariables,
};
